import React, {useEffect} from "react";
import h337 from "heatmap.js";
import {Image} from "react-bootstrap";
import t from "../../../../Localization";
import MainButton from "../../forms/Buttons";
import pitch from "../../../../assets/svg/ils-field-small.svg";
import DetailsColumn from "./DetailsColumn";
import SelectButtons from "../../select/SelectButtons";
import PlayerPositionsHeatMap from "../../canvases/PlayerPositionsHeatMap";
import SelectButtonsWithMore from "../../select/SelectButtonsWithMore";

const {complex, add, multiply, sin, sqrt, pi, equal, sort, format} = require('mathjs');

const HeatMap = (props) => {
    const {src} = props;

    // useEffect(() => {
    //     let heatmapInstance = h337.create({
    //         container: document.querySelector('.heatmap-container'),
    //         radius: 30,
    //         blur: .99,
    //         maxOpacity: .6,
    //         minOpacity: 0,
    //         gradient: {
    //             // enter n keys between 0 and 1 here
    //             // for gradient color customization
    //             '0.00': '#71B78A20',
    //             '0.10': '#71B78A80',
    //             // '0.35': '#F5E33D70',
    //             '0.25': '#71B78Aff',
    //             '0.85': '#F5E33Dff',
    //             // '0.79': '#F5E33D70',
    //             // '0.80': '#EF232370',
    //             '0.99': '#EF2323',
    //         }
    //     });
    //
    //     // now generate some random data
    //     let points = [];
    //     let max = 0;
    //     let width = 170;
    //     let height = 228;
    //     let len = 6;
    //
    //     for (let i = 0; i < len; i++) {
    //         let val = Math.floor(Math.random() * 100);
    //         max = Math.max(max, val);
    //
    //         let o = complex(width / 2, height / 2);
    //         let r = 45 + Math.floor(Math.random() * 20);
    //         let phi = pi / 3 * i / len - pi / 2;
    //         let z = add(o, complex({r: r, phi: phi}));
    //
    //         let point = {
    //             x: z.re,
    //             y: z.im,
    //             value: val,
    //         };
    //         points.push(point);
    //     }
    //
    //     let data = {
    //         data: points,
    //     };
    //
    //     heatmapInstance.setData(data);
    // });
    // return (
    //     <div className="heatmap-container" style={{height: '228px', width: '170px'}}>
    //         <Image src={src}/>
    //     </div>
    // );


};

class PlayedPositionMap extends DetailsColumn {
    state = {
        positionCode: null,
    };

    renderBody = () => {
        return (
            <div className="played-position-map-body">
                {this.renderFilters()}
                {this.renderPitch()}
            </div>
        );
    };

    renderFilters = () => {
        const {data} = this.props;
        const options = data?.map(item => item.position)?.map((key) => ({label: key, value: key}));

        return (
            <div className="filter-container">
                <SelectButtonsWithMore className="w-100" color="secondary" limit={3} split secondary size="sm" options={options} defaultValue={options[0]?.value} onChange={this.handlePositionChange}/>
                {/*<SelectButtons size="sm" options={options} split={true} defaultValue={options[0]?.value} ={this.handlePositionChange}/>*/}
            </div>
        );
    };

    renderPitch = () => {
        const {positionCode} = this.state;
        return (
            <div className="heatmap-container" style={{marginBottom: 20}}>
                <PlayerPositionsHeatMap positionCode={positionCode}/>
            </div>
        );
    };

    handlePositionChange = option => {
        this.setState({
            positionCode: option.value,
        });
    };

    static defaultProps = {
        headerTitle: "Played Position Map"
    };

    getComponentClassName = () => 'played-position-map';
}

export default PlayedPositionMap;
